import { setGeofenceAreas } from '@customer/store/slices/filtersSlice';
import { useTranslation } from 'react-i18next';
import { FilterInputProps } from '@customer/filters/types';
import { MultiselectFilter } from './MultiselectFilter';
import { NameIdBasicModel } from '@customer/store/apis/commonModels';
import { useGetGeofenceAreasQuery } from '@customer/store/apis/metadataApi';
import { useMemo } from 'react';
import { DropdownItemProps } from '@cas/components/inputs/dropdown-items/DropdownItems';

export const useGeofenceAreasOptions = (): DropdownItemProps<number>[] => {
  const { data: geofenceGroups } = useGetGeofenceAreasQuery(undefined, {
    refetchOnMountOrArgChange: 60,
  });

  return useMemo(() => {
    return geofenceGroups
      ? geofenceGroups.map(({ id, n: label }: NameIdBasicModel) => {
          const stringValue = id.toString();
          return { key: stringValue, value: id, stringValue, label };
        })
      : [];
  }, [geofenceGroups]);
};

export const GeofenceAreasFilter = ({
  label,
  elementRef,
}: FilterInputProps<HTMLVdsBasicDropdownMultiselectElement>) => {
  const { t } = useTranslation();

  return (
    <MultiselectFilter<number>
      filterName="geofenceAreas"
      label={label ?? t('GeofenceArea')}
      action={setGeofenceAreas}
      elementRef={elementRef}
      useItemsHook={useGeofenceAreasOptions}
    />
  );
};

export default GeofenceAreasFilter;
